import { gql } from '@apollo/client';

export const LANGUAGE_CREATE = gql`
    mutation LanguageCreate(
        $input: LanguageFieldsInput!
    ){
        languageCreate(
            input: $input
        ){
            label
            message
            language{
                id
                label
                slug
                status
            }
        }
    }
`;

export const LANGUAGE_UPDATE = gql`
    mutation LanguageUpdate(
        $id: ID,
        $input: LanguageFieldsInput!
    ){
        languageUpdate(
            id: $id,
            input: $input
        ){
            label
            message
            language{
                id
                label
                slug
                status
            }
        }
    }
`;

export const LANGUAGE_DELETE = gql`
    mutation LanguageDelete(
        $id: ID!
    ){
        languageDelete(
            id: $id
        ){
            label
            message
        }
    }
`;
